module.exports = __webpack_public_path__ + "static/media/web-only-graphic.c63acad7.png";